// src/pages/Section.js

import React from "react";
import { Link } from "react-router-dom";
import potUrl from "../assets/potfin.png";
import logoXL from "../assets/logoBig.png";

// On importe les icônes pour la nouvelle section
import { FaSearch, FaBook, FaLandmark } from 'react-icons/fa';

// On définit les cartes de fonctionnalités ici pour garder le code propre
const features = [
  {
    icon: <FaSearch />,
    title: "Recherche Intuitive",
    description: "Accédez instantanément à des définitions précises, des synonymes et des contextes d'usage grâce à notre moteur de recherche optimisé.",
    link: "/recherche"
  },
  {
    icon: <FaBook />,
    title: "Grammaire Approfondie",
    description: "Maîtrisez la structure de la langue avec des fiches détaillées sur la syntaxe, la morphologie et les règles d'accord du Kinyarwanda.",
    link: "/elementsdegrammaire"
  },
  {
    icon: <FaLandmark />,
    title: "Héritage Historique",
    description: "Explorez les racines du Rwanda à travers une documentation rigoureuse, des origines des royaumes jusqu'à l'ère moderne.",
    link: "/brevehistoire"
  }
];

export default function Section() {
  return (
    // On utilise un Fragment <> pour retourner plusieurs sections
    <div className="page-container">
      <div className="homepage-container">
        <div className="homepage-left-panel">
          <img src={potUrl} alt="Pot traditionnel rwandais" />
        </div>
        <div className="homepage-center-panel">
          <img src={logoXL} alt="Logo Nyamunini" className="main-logo-xl" />
          <p className="main-description-text">
            Dictionnaire bilingue et encyclopédique kinyarwanda-français
            <br />
            <span style={{ display: "block", marginTop: "0.5rem", fontStyle: "italic" }}>
              Inkoranya rukusanya ndimebyiri ikinyarwanda-igifaransa
            </span>
          </p>
          <div className="main-buttons-group">
            <Link to="/identification" className="ny-home-btn ny-home-btn--secondary">
              Créer un compte
            </Link>
            <Link to="/connexion" className="ny-home-btn ny-home-btn--primary">
              Se connecter
            </Link>
          </div>
        </div>
      </div>
          {/*SECTION DE PRÉSENTATION*/}
      <section className="features-section">
        <h2>Découvrez le dictionnaire</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <Link to={feature.link} key={index} className="feature-card">
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </Link>
          ))}
        </div>
      </section>

    </div>
  );
}